// src/media.ts
function getExternalUrl(url, options) {
  const { usfUrl, teamId } = options;
  if (!url) {
    return "";
  }
  if (url.includes("usf://")) {
    return url.replace("usf://", `${usfUrl}/${teamId}/`);
  }
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `${usfUrl}/${teamId}/${url}`;
}

// src/text.ts
function renderText(text, options = {}) {
  const { phrases = [], truncationLimit = 100 } = options;
  if (!text) return "";
  let processedText = processLiquid(text, phrases);
  const plainText = stripHtml(processedText);
  return plainText.length > truncationLimit ? plainText.substring(0, truncationLimit) + "..." : plainText;
}
function processLiquid(text, phrases) {
  return text.replace(/\{\{\s*phrases\.(\w+)\s*\}\}/g, (match, phraseId) => {
    if (!Array.isArray(phrases)) {
      return match;
    }
    const phrase = phrases.find((p) => p.id === phraseId);
    return phrase ? phrase.fallbackText : match;
  });
}
function stripHtml(html) {
  if (!html) return "";
  if (typeof document !== "undefined") {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }
  return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "").replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/\s+/g, " ").trim();
}
function capitalize(x) {
  if (x && x.length) {
    const firstLetterIndex = x.search(/[a-zA-Z]/);
    if (firstLetterIndex !== -1) {
      return x.slice(0, firstLetterIndex) + x[firstLetterIndex].toUpperCase() + x.slice(firstLetterIndex + 1);
    }
  }
  return x;
}
function toSentence(x) {
  if (x.length === 1) {
    return x[0];
  }
  return x.slice(0, x.length - 1).join(", ") + " and " + x[x.length - 1];
}

// src/segmentName.ts
function segmentName(segment, options) {
  if (!segment) return null;
  if (segment.name === "INT_OTHER") {
    if (options?.segmentGroups && options?.questions) {
      const segmentGroup = options.segmentGroups.find(
        (sg) => sg.segments.some((s) => s.id === segment.id)
      );
      if (segmentGroup) {
        const question = options.questions.find(
          (q) => q.segmentGroupId === segmentGroup.id
        );
        if (question?.otherOptions?.otherLabel) {
          return question.otherOptions.otherLabel;
        }
      }
    }
    return "Other";
  }
  return segment.name;
}

// src/variantName.ts
function getVariantDisplayName(variant, dimensions = []) {
  const hasCustomName = variant.name && variant.name.trim() !== "" && variant.name !== "New Variant";
  if (hasCustomName) {
    const strippedName = stripHtml(variant.name);
    return strippedName;
  }
  const rules = variant.rules;
  if (!rules) {
    return "Undefined Audience";
  }
  const segmentNames = [];
  const allRules = [...rules.all || [], ...rules.any || []];
  allRules.forEach((rule) => {
    if (rule.dimensionId && rule.segment) {
      const dimension = dimensions.find((d) => d.id === rule.dimensionId);
      if (dimension?.segments) {
        const segment = dimension.segments.find((s) => s.id === rule.segment);
        if (segment) {
          const segmentLabel = segment.name === "INT_OTHER" ? "Other" : stripHtml(segment.name);
          segmentNames.push(segmentLabel);
        }
      }
    }
  });
  if (segmentNames.length === 0) {
    return "Undefined Audience";
  }
  return segmentNames.join(" x ");
}
function getVariantDisplayNames(variants, dimensions = []) {
  const names = {};
  variants.forEach((variant) => {
    names[variant.id] = getVariantDisplayName(variant, dimensions);
  });
  return names;
}

// src/liquidUtils.ts
import { Liquid } from "liquidjs";
function safeLiquidRender(template, context = {}, engine) {
  try {
    const liquidEngine = engine || new Liquid();
    return liquidEngine.parseAndRenderSync(template || "", context);
  } catch (error) {
    return template || "";
  }
}
export {
  capitalize,
  getExternalUrl,
  getVariantDisplayName,
  getVariantDisplayNames,
  processLiquid,
  renderText,
  safeLiquidRender,
  segmentName,
  stripHtml,
  toSentence
};
//# sourceMappingURL=index.js.map